import React from 'react';
import { connect } from 'react-redux';
import {
  getKeypadReadingLeft,
  getKeypadReadingRight,
} from 'PointOfSale/state/selectors';

import { KEYPAD_KEYS } from 'PointOfSale/modules/common/constants';

const mapStateToProps = state => ({
  readingLeft: getKeypadReadingLeft(state),
  readingRight: getKeypadReadingRight(state),
});

const withIgnoreKeypadInput = InputComponent => {
  class InputWithIgnoreKeypadInput extends React.Component {
    onKeyPress = e => {
      const { readingLeft, readingRight, onKeyPress } = this.props;
      let rejectInput = false;

      let key = e.key;

      switch (key) {
        case KEYPAD_KEYS.LEFT:
        case KEYPAD_KEYS.RIGHT:
          rejectInput = true;
          break;
        default:
          if (readingLeft || readingRight) {
            rejectInput = true;
          }
          break;
      }

      if (rejectInput) {
        // Ignores the character by preventing the subsequent events that are fired after a keypress
        e.preventDefault();
      }

      if (onKeyPress) {
        onKeyPress(e);
      }
    };

    render() {
      const {
        dispatch,
        readingLeft,
        readingRight,
        onKeyPress,
        forwardedRef,
        ...rest
      } = this.props;

      return (
        <InputComponent
          onKeyPress={this.onKeyPress}
          {...rest}
          ref={forwardedRef}
        />
      );
    }
  }

  return connect(mapStateToProps)(InputWithIgnoreKeypadInput);
};

export { withIgnoreKeypadInput };



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/component/withIgnoreKeypadInput.js